import {Message} from 'google-protobuf';
import {
  ClientReadableStream,
  Request,
  StreamInterceptor,
  UnaryInterceptor,
  UnaryResponse,
} from 'grpc-web';

import {getSsoSessionToken} from './auth_interceptor';

// TODO(b/546645627): Unify interceptors to function-only providers once worker token passing is refactored.
export type TokenProvider = string | null | (() => string | null);

/**
 * A gRPC-Web Unary Interceptor that dynamically extracts the SSO session token
 * from cookies on each unary call and attaches it to the Authorization metadata header.
 *
 * Supports an optional token provider function or static string (for Web Workers / tests).
 */
export class AuthHeaderUnaryInterceptor implements UnaryInterceptor<Message, Message> {
  constructor(private readonly tokenProvider?: TokenProvider) {}

  intercept(
    request: Request<Message, Message>,
    invoker: (request: Request<Message, Message>) => Promise<UnaryResponse<Message, Message>>,
  ): Promise<UnaryResponse<Message, Message>> {
    let token: string | null = null;
    if (this.tokenProvider === undefined) {
      token = getSsoSessionToken();
    } else if (typeof this.tokenProvider === 'function') {
      token = this.tokenProvider();
    } else {
      token = this.tokenProvider;
    }
    if (token !== null && token !== '') {
      const metadata = request.getMetadata();
      metadata['Authorization'] = `Bearer ${token}`;
    }
    return invoker(request);
  }
}

/**
 * A gRPC-Web Stream Interceptor that dynamically extracts the SSO session token
 * from cookies on each streaming call and attaches it to the Authorization metadata header.
 *
 * Supports an optional token provider function or static string (for Web Workers / tests).
 */
export class AuthHeaderStreamInterceptor implements StreamInterceptor<Message, Message> {
  constructor(private readonly tokenProvider?: TokenProvider) {}

  intercept(
    request: Request<Message, Message>,
    invoker: (request: Request<Message, Message>) => ClientReadableStream<Message>,
  ): ClientReadableStream<Message> {
    let token: string | null = null;
    if (this.tokenProvider === undefined) {
      token = getSsoSessionToken();
    } else if (typeof this.tokenProvider === 'function') {
      token = this.tokenProvider();
    } else {
      token = this.tokenProvider;
    }
    if (token !== null && token !== '') {
      const metadata = request.getMetadata();
      metadata['Authorization'] = `Bearer ${token}`;
    }
    return invoker(request);
  }
}
